import { defineMessages } from 'react-intl';

export default defineMessages({
  explorer: 'Go to Explorer',
  dashboard: 'Go to Dashboard',
  congrats: 'Congrats, your txn has been successfully executed!',
  txId: 'Tx id: ',
  error: 'There was an error',
});
